import { bl_fi_my_einvoice_request_rejection_internal_doc_hdr_RowClass, bl_fi_my_einvoice_request_rejection_internal_doc_hdr_RowInterface } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class MyEInvoiceRequestRejectionContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_request_rejection_internal_doc_hdr: bl_fi_my_einvoice_request_rejection_internal_doc_hdr_RowInterface = new bl_fi_my_einvoice_request_rejection_internal_doc_hdr_RowClass();
}